import api from './api'
import users from './users'
import jobs from './jobs'
import interviews from './interviews'
import manageJobs from './manage-jobs'
import crews from './crews'
import auth from './auth'
import message from './message'
import wages from './wages'
import companies from './companies'
import reference from './reference'
import region from './region'
import toast from './toast'
import payroll from './payroll'
import shifts from './shifts'
import segmentPixel from './segment-pixel'
import paystub from './paystub'
import paylocity from './paylocity'
import PayrollClient from "../services/clients/plaid.client";
import OneTrustConsentService from '../services/onetrust.service'

import angular from 'angular'

export default angular.module('shared', [])
  .constant('API', api)
  .service('PayrollClient', PayrollClient)
  .service('Auth', auth)
  .service('AuthService', auth)
  .service('userConsent', OneTrustConsentService)
  .factory('Users', users)
  .factory('UsersService', users)
  .factory('Crews', crews)
  .factory('CrewsService', crews)
  .factory('Jobs', jobs)
  .factory('JobsService', jobs)
  .factory('InterviewsService', interviews)
  .factory('ManageJobs', manageJobs)
  .factory('Companies', companies)
  .factory('CompaniesService', companies)
  .factory('Wages', wages)
  .factory('Message', message)
  .factory('MessagesService', message)
  .factory('ReferenceService', reference)
  .factory('Region', region)
  .factory('ToastService', toast)
  .factory('Payroll', payroll)
  .factory('PayrollService', payroll)
  .factory('Shifts', shifts)
  .factory('SegmentPixel', segmentPixel)
  .factory('Paystub', paystub)
  .factory('PaylocityService', paylocity)
